/*
  mayie-quiz-loader: pornește motorul quiz-ului Skin Lab (assets/mayie-quiz.js, generat din mayie-skinlab, 22,5 KB gzip)
  doar când e nevoie, pe Dawn. Inclus de sections/mayie-quiz.liquid (defer); se leagă o singură dată pe pagină.

  1. Încărcarea: imediat pe paginile quiz-ului (mod „entry”/„result”, intrarea cu buton, link partajat ?a=) și în
     editorul de temă; pe prima pagină (banda cu prima întrebare, mod „auto”) abia când banda intră în ecran sau
     vizitatorul o atinge (pointerdown/focus). Bugetul de JS al temei pe prima pagină e 35 KB gzip (AGENTS.md).
     Un răspuns atins înainte să se încarce motorul nu se pierde: îl ținem apăsat, încărcăm motorul și îl redăm.
  2. Podul pub/sub: în Dawn `PUB_SUB_EVENTS` e `const` (constants.js), nu proprietate pe window, iar motorul caută
     `window.PUB_SUB_EVENTS`; fără pod, coșul afla de adăugare doar prin evenimentul de rezervă. `publish`/`subscribe`
     (pubsub.js) sunt deja pe window.
  3. Acordul (D6): evenimentele anonime ale quiz-ului (POST <api_base>/api/web/events, sendBeacon sau fetch) pleacă
     doar dacă vizitatorul a acceptat statisticile (Shopify Customer Privacy: analyticsProcessingAllowed()). Altfel se
     opresc aici, fără eroare. Lead-urile (/api/web/leads) au consimțământul lor în formular și trec neschimbate.
     Locul corect al regulii e motorul din mayie-skinlab; poarta de aici rămâne până se mută acolo.
*/
(() => {
  if (window.mayieQuizLoader) return;
  window.mayieQuizLoader = true;

  const roots = () => Array.from(document.querySelectorAll('[data-mayie-quiz]'));
  let state = 'idle';
  let loading = null;

  /* ----- 2. pod pub/sub ----- */
  const bridge = () => {
    try {
      // eslint-disable-next-line no-undef
      if (!window.PUB_SUB_EVENTS && typeof PUB_SUB_EVENTS !== 'undefined') window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
    } catch (e) {
      /* constants.js lipsește: motorul folosește evenimentul de rezervă */
    }
  };

  /* ----- 3. poarta de acord pentru statistici ----- */
  const analyticsAllowed = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed());
    } catch (e) {
      return false;
    }
  };

  const installConsentGate = () => {
    const bases = roots()
      .map((root) => (root.dataset.apiBase || '').replace(/\/$/, ''))
      .filter(Boolean);
    if (!bases.length) return;
    const isEvents = (url) => {
      const href = String(url || '');
      return href.indexOf('/api/web/events') !== -1 && bases.some((base) => href.indexOf(base) === 0);
    };

    if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
      } catch (e) {
        /* fără API: statisticile rămân oprite */
      }
    }

    if (navigator.sendBeacon) {
      const beacon = navigator.sendBeacon.bind(navigator);
      navigator.sendBeacon = (url, data) => (isEvents(url) && !analyticsAllowed() ? true : beacon(url, data));
    }
    const nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (isEvents(url) && !analyticsAllowed()) return Promise.resolve(new Response(null, { status: 204 }));
      return nativeFetch.apply(this, arguments);
    };
  };

  /* ----- 1. încărcarea motorului ----- */
  const load = () => {
    if (loading) return loading;
    const first = roots()[0];
    const src = first && first.dataset.quizSrc;
    if (!src) return Promise.resolve();
    state = 'loading';
    bridge();
    installConsentGate();
    loading = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        state = 'ready';
        resolve();
      };
      script.onerror = () => {
        state = 'error';
        resolve();
      };
      document.head.appendChild(script);
    });
    return loading;
  };

  const needsNow = (root) => {
    const params = new URLSearchParams(window.location.search);
    return (
      (window.Shopify && window.Shopify.designMode) ||
      params.has('a') ||
      root.dataset.mode !== 'auto' ||
      root.dataset.entryStyle !== 'first_question'
    );
  };

  const watch = (root) => {
    if (root.hasAttribute('data-quiz-loader')) return;
    root.setAttribute('data-quiz-loader', '');

    if (needsNow(root)) {
      load();
      return;
    }

    const wake = () => load();
    root.addEventListener('pointerdown', wake, { once: true, passive: true });
    root.addEventListener('focusin', wake, { once: true });

    // Un răspuns (sau „Începe”) atins înainte de motor: îl ținem și îl redăm după încărcare.
    root.addEventListener(
      'click',
      (event) => {
        if (state === 'ready') return;
        const button = event.target instanceof Element ? event.target.closest('[data-quiz-first-answer], [data-quiz-start]') : null;
        if (!button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        button.setAttribute('aria-pressed', 'true');
        load().then(() => {
          button.removeAttribute('aria-pressed');
          if (state === 'ready' && button.isConnected) button.click();
        });
      },
      true
    );

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          load();
        }
      });
      observer.observe(root);
    } else {
      load();
    }
  };

  roots().forEach(watch);
  document.addEventListener('shopify:section:load', () => roots().forEach(watch));
})();
